import type { ScheduleTranslation } from './schedule.en'

export const scheduleNe: ScheduleTranslation = {
  common: {
    after: `पछि`,
    cancel: `रद्द गर्नुहोस्`,
    clear: `खाली गर्नुहोस्`,
    closed: `बन्द`,
    create: `सिर्जना गर्नुहोस्`,
    daily: `दैनिक`,
    delete: `मेटाउनुहोस्`,
    deleteError: {
      inUseGeneric: `यो तालिका स्विचबोर्डमा प्रयोगमा भएकाले मेटाउन सकिँदैन। स्विचबोर्डबाट हटाएर फेरि प्रयास गर्नुहोस्।`,
      inUseMultiple: `यो तालिका यी स्विचबोर्डहरूमा प्रयोगमा भएकाले मेटाउन सकिँदैन: {{switchboardNames}}। ती स्विचबोर्डहरूबाट हटाएर फेरि प्रयास गर्नुहोस्।`,
      inUseSingle: `यो तालिका यस स्विचबोर्डमा प्रयोगमा भएकाले मेटाउन सकिँदैन: {{switchboardNames}}। त्यो स्विचबोर्डबाट हटाएर फेरि प्रयास गर्नुहोस्।`,
      listWithMore: `{{visibleNames}}, र थप {{remaining}}`,
    },
    description: `विवरण`,
    edit: `सम्पादन गर्नुहोस्`,
    from: `देखि`,
    holiday: `बिदा`,
    monthly: `मासिक`,
    name: `नाम`,
    never: `कहिल्यै होइन`,
    onDate: `मितिमा`,
    routing: `राउटिङ`,
    save: `सेभ गर्नुहोस्`,
    saving: `सेभ हुँदैछ...`,
    timeZone: `समय क्षेत्र`,
    to: `सम्म`,
    validationErrorTitle: `मान्यकरण त्रुटि`,
    weekdayShort: {
      fri: `शुक्र`,
      mon: `सोम`,
      sat: `शनि`,
      sun: `आइत`,
      thu: `बिही`,
      tue: `मंगल`,
      wed: `बुध`,
    },
    weekdayLong: {
      fri: `शुक्रबार`,
      mon: `सोमबार`,
      sat: `शनिबार`,
      sun: `आइतबार`,
      thu: `बिहीबार`,
      tue: `मंगलबार`,
      wed: `बुधबार`,
    },
    weekly: `साप्ताहिक`,
    yearly: `वार्षिक`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `तालिका मेटाउनुहोस्`,
      deleteScheduleTitle: `तालिका मेटाउनुहोस्`,
      editScheduleTitle: `तालिका सम्पादन गर्नुहोस्`,
    },
    currentRouting: `हालको राउटिङ:`,
    error: `त्रुटि`,
    header: {
      breadcrumbCurrent: `तालिका सम्पादन`,
      breadcrumbRoot: `तालिकाहरू`,
    },
    hoursView: {
      calendar: `क्यालेन्डर`,
      list: `सूची`,
    },
    loading: `तालिका लोड हुँदैछ...`,
    notFound: {
      description: `तपाईंले खोज्नु भएको तालिका उपलब्ध छैन।`,
      title: `तालिका फेला परेन`,
    },
    toast: {
      createOverrideFailedTitle: `ओभरराइड सिर्जना गर्न असफल`,
      createWeeklyHoursFailedTitle: `साप्ताहिक समय सिर्जना गर्न असफल`,
      deleteEventFailedTitle: `इभेन्ट मेटाउन असफल`,
      deleteScheduleFailedTitle: `तालिका मेटाउन असफल`,
      eventDeleted: `इभेन्ट सफलतापूर्वक मेटियो`,
      eventsUpdatedDescription: `{{count}} इभेन्टको समय क्षेत्र अद्यावधिक गरियो`,
      eventsUpdatedTitle: `इभेन्ट अद्यावधिक भयो`,
      failedTitle: `असफल`,
      genericError: `एउटा त्रुटि भयो`,
      holidaysAddFailed: `{{count}} बिदा थप्न असफल`,
      holidaysAddedSuccess: `{{count}} बिदा सफलतापूर्वक थपियो`,
      holidaysAddedWithFailures: `{{successCount}} बिदा सफलतापूर्वक थपियो ({{errorCount}} असफल)`,
      loadEventsFailedDescription: `इभेन्ट लोड गर्दा त्रुटि भयो`,
      loadEventsFailedTitle: `तालिकाका इभेन्ट लोड गर्न असफल`,
      loadScheduleFailedDescription: `तालिका लोड गर्दा त्रुटि भयो`,
      loadScheduleFailedTitle: `तालिका लोड गर्न असफल`,
      overrideCreated: `ओभरराइड सफलतापूर्वक सिर्जना भयो`,
      overrideUpdated: `ओभरराइड सफलतापूर्वक अद्यावधिक भयो`,
      scheduleDeleted: `तालिका सफलतापूर्वक मेटियो`,
      scheduleUpdated: `तालिका सफलतापूर्वक अद्यावधिक भयो`,
      successTitle: `सफल`,
      updateOverrideFailedTitle: `ओभरराइड अद्यावधिक गर्न असफल`,
      updateScheduleFailedTitle: `तालिका अद्यावधिक गर्न असफल`,
      updateWeeklyHoursFailedTitle: `साप्ताहिक समय अद्यावधिक गर्न असफल`,
      weeklyHoursCreated: `साप्ताहिक समय सफलतापूर्वक सिर्जना भयो`,
      weeklyHoursUpdated: `साप्ताहिक समय सफलतापूर्वक अद्यावधिक भयो`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `बिदा थप्नुहोस् ({{count}})`,
    },
    common: {
      unknown: `अज्ञात`,
    },
    customPrompt: {
      link: `आफ्नो विशेष समय सेट गर्नुहोस्`,
      prefix: `तपाईंले खोजेको बिदा देख्नुभएन?`,
    },
    empty: `कुनै प्रिसेट बिदा उपलब्ध छैन`,
    error: {
      failedToLoad: `बिदाहरू लोड गर्न असफल`,
    },
    loading: `बिदाहरू लोड हुँदैछन्...`,
    modal: {
      description: `आफ्नो ओभरराइड सूचीमा थप्न चाहनुभएको बिदा प्रिसेटहरू छान्नुहोस्। प्रत्येक बिदाको समय इभेन्ट बनेपछि सम्पादन गरेर मिलाउन सकिन्छ।`,
      title: `प्रिसेट बिदा थप्नुहोस्`,
    },
    submitting: `तपाईंको तालिका अद्यावधिक हुँदैछ, कृपया केही क्षण पर्खनुहोस्।`,
    table: {
      holiday: `बिदा`,
      nextOccurrence: `अर्को हुने मिति`,
    },
    validation: {
      noneSelectedDescription: `थप्न कम्तिमा एउटा बिदा चयन गर्नुहोस्`,
      noneSelectedTitle: `कुनै बिदा चयन गरिएको छैन`,
    },
  },
  list: {
    card: {
      lastUpdated: `अन्तिम अद्यावधिक`,
    },
    common: {
      notAvailable: `उपलब्ध छैन`,
    },
    delete: `मेटाउनुहोस्`,
    deleteTitle: `तालिका मेटाउनुहोस्`,
    empty: `कुनै तालिका फेला परेन`,
    grid: {
      errorTitle: `त्रुटि`,
    },
    hoursVary: `समय फरक पर्न सक्छ`,
    loading: `तालिकाहरू लोड हुँदैछन्...`,
    newSchedule: `नयाँ तालिका`,
    noPermission: `तपाईंलाई तालिकामा पहुँच गर्ने अनुमति छैन।`,
    noSchedules: `कुनै तालिका फेला परेन`,
    noSchedulesDescription: `आफ्नो उपलब्धता थप्न नयाँ तालिका थप्नुहोस्`,
    pagination: {
      all: `सबै`,
      jumpToPage: `पृष्ठ {{page}} मा जानुहोस्`,
      nextPage: `अर्को पृष्ठ`,
      previousPage: `अघिल्लो पृष्ठ`,
      resultsPerPage: `प्रति पृष्ठ परिणाम:`,
    },
    status: {
      closed: `बन्द`,
      holiday: `बिदा`,
      openNow: `अहिले खुला`,
    },
    subtitle: `तालिका कन्फिगरेसन हेर्नुहोस् र व्यवस्थापन गर्नुहोस्`,
    title: `तालिकाहरू`,
    toast: {
      createFailed: `सिर्जना असफल`,
      createFailedDescription: `तालिका सिर्जना गर्न असफल`,
      createSuccess: `तालिका सिर्जना भयो`,
      createSuccessDescription: `तालिका सफलतापूर्वक सिर्जना भयो।`,
      deleteFailed: `मेटाउन असफल`,
      deleteFailedDescription: `तालिका मेटाउन असफल`,
      deleteSuccess: `तालिका मेटियो`,
      deleteSuccessDescription: `तालिका सफलतापूर्वक मेटियो।`,
    },
    unavailable: `अनुपलब्ध`,
  },
  modal: {
    create: {
      cancel: `रद्द गर्नुहोस्`,
      defaultWeeklyHoursLabel: `पूर्वनिर्धारित साप्ताहिक समय समावेश गर्नुहोस्`,
      descriptionLabel: `विवरण`,
      descriptionPlaceholder: `यो तालिकाको वैकल्पिक विवरण`,
      nameLabel: `नाम`,
      namePlaceholder: `व्यवसाय समय`,
      saveSchedule: `तालिका सेभ गर्नुहोस्`,
      saving: `सेभ हुँदैछ...`,
      timeZoneLabel: `समय क्षेत्र`,
      title: `नयाँ तालिका`,
      validationNameRequired: `कृपया तालिकाको नाम लेख्नुहोस्`,
      validationTitle: `मान्यकरण`,
    },
    deleteConfirmation: {
      cancel: `रद्द गर्नुहोस्`,
      confirm: `मेटाउनुहोस्`,
      defaultBodyWithItemPrefix: `के तपाईं निश्चित रूपमा `,
      defaultBodyWithItemSuffix: ` मेटाउन चाहनुहुन्छ? यो कार्य फिर्ता गर्न मिल्दैन।`,
      defaultBodyWithoutItem: `के तपाईं निश्चित रूपमा यो आइटम मेटाउन चाहनुहुन्छ? यो कार्य फिर्ता गर्न मिल्दैन।`,
      defaultTitle: `आइटम मेटाउनुहोस्`,
    },
    editSchedule: {
      applyTimezoneChanges: `समय क्षेत्र परिवर्तन लागू गर्ने:`,
      customEventsHelp: `यदि विद्यमान कस्टम इभेन्टहरूको समय क्षेत्र परिवर्तन गर्न चाहनुहुन्न भने यो विकल्प हटाउनुहोस्।`,
      customEventsWithCount: `कस्टम इभेन्टहरू ({{count}})`,
      descriptionPlaceholder: `यो तालिकाको वैकल्पिक विवरण`,
      namePlaceholder: `व्यवसाय समय`,
      timezoneWarning: `यसले तपाईंको साप्ताहिक समय चयन गरिएको समय क्षेत्रमा अद्यावधिक गर्छ।`,
      title: `तालिका सम्पादन गर्नुहोस्`,
      updateSchedule: `तालिका अद्यावधिक गर्नुहोस्`,
      validation: {
        nameRequired: `कृपया तालिकाको नाम लेख्नुहोस्`,
      },
    },
    override: {
      dateTime: `मिति र समय`,
      dateType: {
        multipleDays: `धेरै दिन`,
        singleDay: `एक दिन`,
      },
      endRepeat: `दोहोरो समाप्त`,
      irregularRepeat: `यो ओभरराइड अनियमित दोहोरिने ढाँचामा छ र सम्पादन गर्न सकिँदैन`,
      irregularRepeatNamed: `{{name}} मा सम्पादन गर्न नसकिने दोहोरिने ढाँचा छ।`,
      irregularRepeatNextOccurrence: `अर्को घटना {{occurrence}} हो`,
      holidayTemplateCheckPending: `{{name}} को दोहोरिने ढाँचा जाँचिँदैछ। मिति र दोहोरिने नियन्त्रणहरू अस्थायी रूपमा उपलब्ध छैनन्।`,
      holidayTemplateCheckUnavailable: `{{name}} को दोहोरिने ढाँचा पुष्टि गर्न सकिएन। मिति र दोहोरिने नियन्त्रणहरू उपलब्ध छैनन्।`,
      loadingDetails: `ओभरराइड विवरण लोड हुँदैछ...`,
      monthly: {
        nthWeekday: `{{nth}}{{suffix}} {{weekday}}`,
        specificDate: `{{day}}{{suffix}}`,
      },
      namePlaceholder: `ओभरराइड नाम`,
      startTimeAriaLabel: `सुरु समय`,
      startDateAriaLabel: `सुरु मिति`,
      endDateAriaLabel: `अन्त्य मिति`,
      endRepeatDateAriaLabel: `दोहोरो समाप्त मिति`,
      endTimeAriaLabel: `अन्त्य समय`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}} पूर्वाह्न/अपराह्न`,
      meridiemOptionsAriaLabel: `{{label}} पूर्वाह्न/अपराह्न विकल्पहरू`,
      timeOptionsAriaLabel: `{{label}} विकल्पहरू`,
      occurrences: `पटक`,
      repeat: `दोहो-याउनुहोस्`,
      repeatEvery: `हरेक दोहोरिने अन्तर`,
      repeatOn: `यस दिन दोहोरिने`,
      repeatUnit: {
        days: `दिन`,
        months: `महिना`,
        weeks: `हप्ता`,
        years: `वर्ष`,
      },
      timeType: {
        closedAllDay: `पूरै दिन बन्द`,
        setClosedHours: `बन्द समय सेट गर्नुहोस्`,
      },
      titleCreate: `ओभरराइड थप्नुहोस्`,
      titleEdit: `तालिका ओभरराइड सम्पादन`,
      validation: {
        endAfterStart: `समाप्ति मिति/समय सुरुवातपछि हुनुपर्छ`,
        endDateRequired: `धेरै-दिने इभेन्टका लागि समाप्ति मिति चयन गर्नुहोस्`,
        endDateRequiredShort: `कृपया समाप्ति मिति चयन गर्नुहोस्`,
        invalidDateTime: `कृपया मान्य मिति र समय प्रविष्ट गर्नुहोस्`,
        monthRequired: `वार्षिक दोहोराइका लागि महिना चयन गर्नुहोस्`,
        monthlyPatternRequired: `मासिक दोहोराइ ढाँचा चयन गर्नुहोस्`,
        nameRequired: `ओभरराइडको नाम प्रविष्ट गर्नुहोस्`,
        occurrencesRequired: `कृपया कति पटक दोहोरिने हो प्रविष्ट गर्नुहोस्`,
        startEndTimeRequired: `सुरु र अन्त्य समय चयन गर्नुहोस्`,
        validDayRequired: `मान्य दिन चयन गर्नुहोस् (1-31)`,
        validWeekdayPatternRequired: `मान्य हप्ताको दिन ढाँचा चयन गर्नुहोस्`,
        weekdayRequired: `कम्तिमा एक हप्ताको दिन चयन गर्नुहोस्`,
      },
      yearly: {
        nthWeekday: `{{month}} को {{nth}}{{suffix}} {{weekday}}`,
        specificDate: `{{month}} को {{day}}{{suffix}}`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `बिदा थप्नुहोस्`,
      addOverride: `ओभरराइड थप्नुहोस्`,
    },
    empty: `कुनै तालिका ओभरराइड कन्फिगर गरिएको छैन`,
    item: {
      deleteHolidayTitle: `बिदा मेटाउनुहोस्`,
      deleteOverrideModalTitle: `ओभरराइड मेटाउनुहोस्`,
      deleteOverrideTitle: `ओभरराइड मेटाउनुहोस्`,
      editOverrideTitle: `ओभरराइड सम्पादन गर्नुहोस्`,
      overrideInEffect: `ओभरराइड लागू छ`,
      repeatsPrefix: `दोहो-याइन्छ`,
    },
    title: `तालिका ओभरराइडहरू`,
  },
  status: {
    closed: `बन्द`,
    holiday: `बिदा`,
    open: `खुला`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `यो चयन गरिएको समय दायरामा नयाँ तालिका इन्ट्री सिर्जना गर्ने?`,
      confirmCreateTitle: `तालिका इन्ट्री सिर्जना गर्नुहोस्`,
      confirmDeleteTitle: `समय स्लट मेटाउनुहोस्`,
      deleteEventLabel: `{{day}} {{time}} मेटाउनुहोस्`,
    },
    table: {
      confirmDeleteDayDescription: `के तपाईं {{day}} का सबै समय स्लटहरू मेटाउन निश्चित हुनुहुन्छ? यो कार्य फिर्ता गर्न मिल्दैन।`,
      confirmDeleteDayItem: `{{day}} साप्ताहिक समय`,
      confirmDeleteDayTitle: `समय स्लट मेटाउनुहोस्`,
      confirmDeleteSlotItem: `{{day}} समय स्लट`,
      confirmDeleteSlotTitle: `समय स्लट मेटाउनुहोस्`,
      days: {
        friday: `शुक्रबार`,
        monday: `सोमबार`,
        saturday: `शनिबार`,
        sunday: `आइतबार`,
        thursday: `बिहीबार`,
        tuesday: `मंगलबार`,
        wednesday: `बुधबार`,
      },
      slot: {
        addTitle: `तालिका इन्ट्री थप्नुहोस्`,
        addDayLabel: `{{day}} को समय थप्नुहोस्`,
        deleteTitle: `तालिका इन्ट्री मेटाउनुहोस्`,
        deleteSlotLabel: `{{day}} को {{start}} देखि {{end}} सम्मको समय मेटाउनुहोस्`,
        endPlaceholder: `अन्त्य`,
        startPlaceholder: `सुरु`,
        startTimeLabel: `{{day}} को सुरु समय`,
        startTimeLabelNumbered: `{{day}} को सुरु समय, इन्ट्री {{number}}`,
        endTimeLabel: `{{day}} को अन्त्य समय`,
        endTimeLabelNumbered: `{{day}} को अन्त्य समय, इन्ट्री {{number}}`,
        unavailable: `अनुपलब्ध`,
      },
      toggle: {
        disableDay: `{{day}} बन्द गर्नुहोस्`,
        enableDay: `{{day}} खोल्नुहोस्`,
      },
    },
    timeSelect: {
      noTimesFound: `कुनै समय फेला परेन`,
    },
  },

  queryError: {
    fetchSchedules: `तालिकाहरू ल्याउन असफल`,
    fetchSchedule: `तालिका ल्याउन असफल`,
    fetchEvents: `तालिका घटनाहरू ल्याउन असफल`,
    fetchHolidays: `तालिका बिदाहरू ल्याउन असफल`,
    createSchedule: `तालिका सिर्जना गर्न असफल`,
    updateSchedule: `तालिका अद्यावधिक गर्न असफल`,
    createEvent: `तालिका घटना सिर्जना गर्न असफल`,
    updateEvent: `तालिका घटना अद्यावधिक गर्न असफल`,
    deleteEvent: `तालिका घटना मेटाउन असफल`,
    generic: `केही गलत भयो. कृपया फेरि प्रयास गर्नुहोस्.`,
  },
}
